export default {
  container: {
    maxWidth: '1280px',
    margin: '0 auto 100px'
  }
}
